// import React from 'react';
// import Plot from 'react-plotly.js';

// const TryNewBatteryDigitalTwin = () => {
//   return (
//     <Plot
//       data={[
//         {
//           type: 'indicator',
//           mode: 'gauge+number',
//           value: 600,
//           title: { text: 'SOH', font: { size: 24 } },
//           gauge: {
//             axis: { range: [null, 600], tickwidth: 1, tickcolor: 'green' },
//             bar: { color: 'green' },
//             bgcolor: 'white',
//             borderwidth: 2,
//             bordercolor: 'gray',
//             steps: [
//               { range: [0, 100], color: 'green' },
//               { range: [0, 100], color: 'white' }
//             ],
//           }
//         }
//       ]}
//       layout={{ width: 400, height: 300, margin: { t: 0, b: 0 } }}
//     />
//   );
// };

// export default TryNewBatteryDigitalTwin;
